import React from 'react'

import Wizard from '@modules/form-wizard'
import SERVICE_PROPS from '@helpers/extract-service-props'
import { BUSINESS_FIELDS, fullName } from '@modules/form-wizard/utils'
import Swal from 'sweetalert2'
import toastr from '@modules/toastr'
import moment from 'moment'

export default class FoodVendor extends React.Component {
  resource = '/moen/health/food_vendors'
  form_key = 'food_vendor'
  defaults = {}

  // Delete lines as needed
  // fee = 99
  free = true
  postpaid = false
  skip_location = true
  hide_buttons = {
    status: true,
    deny: true,
    fee: true,
  }
  custom_actions = [
    {
      text: 'Assign Officer',
      icon: 'bullhorn',
      roles: [['senior_officer']],
      test: r => ['pending', 'processing'].includes(r.application_decision),
      fn: async record => {
        // Get the list of officers
        const officerList = {};
        const { data } = await $app.axios.get(`${this.resource}/show_field_officers`)
        const officerMap = data.records.map(x => {
          return { id: x.id, name: `${x.first_name} ${x.last_name}` }
        })
        this.setState({ all_reviewers: officerMap })
        this.state.all_reviewers.forEach(e => {
          officerList[`${e.id}`] = e.name;
        })

        let officerID = null
        const {isDismissed, value} = await Swal.fire({
          icon: 'question',
          title: 'Assign Officer for inspection',
          html: `
            Select which field officer you would wish to assign to this application.
          `,
          input: 'select',
          inputOptions: officerList,
          showCancelButton: true,
          confirmButtonText: 'Send',
        })
  
        if (isDismissed) return
        officerID = value
        // console.log(officerID)

        const { props, resource, form_key } = this
        const { history, location } = props

        try {
          await $app.axios.put(resource + '/update_application', {
            [form_key]: {
              form_num: record.form_num,
              application_decision: 'assign reviewer',
              reviewer_id: officerID,
            },
          })

          if (location?.state?.view) {
            const view = { ...location.state.view }
            console.log(view)
            view.application_decision = 'assigned reviewer'

            history.replace(location.pathname, {
              ...location.state,
              view,
            })
          }

          toastr.success('Success', 'Application approved for review successfully')
        } catch (error) {
          console.error(error)
          Swal.fire(
            'Oops...',
            error.response?.data?.error || 'An error occurred while approving the application for review',
            'error'
          )
        }
      }
    },
    {
      text: 'Claim Application',
      icon: 'check',
      roles: [['senior_officer']],
      test: r => {
        if (['pending', 'processing'].includes(r.application_decision) && r.reviewer_id == null) {
          return true
        }

        if (['pending', 'processing'].includes(r.application_decision) && $app.current_user.roles.includes('senior_officer') && r.reviewer_id != $app.current_user.id) {
          return true
        }

        return false
      },
      fn: async record => {
        const { isDismissed, value } = await Swal.fire({
          icon: 'question',
          title: 'Claim Application for Review',
          html: `
            Are you claiming this application for review, 
            <strong>${fullName(record.user, 'initial')}</strong>?
          `,
          input: 'select',
          inputOptions: {
            'claimed': "I claim this application for review",
            'no': "I do not wish to claim this application",            
          },
          showCancelButton: true,
        })

        if (isDismissed) return
        if (value === 'no') return

        await this.submitToNewLevel(value, record, null)
      }
    },
    {
      text: 'Confirm Inspection Date',
      icon: 'check-square',
      roles: [['field_officer', 'inspector', 'senior_officer']],
      test: r => {
        if (['pending', 'processing', 'document requested'].includes(r.application_decision) && r.reviewer_id == $app.current_user.id) {
          return true
        }

        return false
      },
      fn: async record => {
        let inspectionDate

        // Set value of Inspection Date
        const datePrompt = await Swal.fire({
          icon: 'question',
          title: 'Inspection Date?',
          html: `
            <p>
              What is your recommended inspection date regarding the applicant,
              <strong>${fullName(record.user, 'initial')}</strong>,
              <br/>
              <span><b>Organization Name:</b> <u>${record.organization_name || 'N/A'}</u></span>,
              <br/>
              <span><b>Vendor Type:</b> <u>${record.vendor_type}</u></span>
              <br/>
              <span><b>Address:</b> <u>${record.address}</u></span>
            </p>

            <div>
              <input type="date" id="inspection-date" class="swal2-input" min="${moment().format('YYYY-MM-DD')}">
            </div>
          `,

          showCancelButton: true,
          confirmButtonText: 'Submit',
          preConfirm: () => {
            const date = (document.getElementById('inspection-date')).value;
            if (!date) {
              Swal.showValidationMessage('Please select a date');
            }
            console.log(date)
            return date;
          },
        })
  
        if (datePrompt.isDismissed) return

        inspectionDate = datePrompt.value
    
        if (inspectionDate) {
          const { isConfirmed } = await Swal.fire({
            icon: 'question',
            title: 'Confirm Details',
            html: `
              <p>
                What is your recommended inspection date regarding the applicant,
                <strong>${fullName(record.user, 'initial')}</strong>,
                <br/>
                <span><b>Organization Name:</b> <u>${record.organization_name || 'N/A'}</u></span>,
                <br/>
                <span><b>Vendor Type:</b> <u>${record.vendor_type}</u></span>
                <br/>
                <span><b>Address:</b> <u>${record.address}</u></span>
              </p>
              Inspection date to be: <b>${inspectionDate}</b>
              <br/>
            `,
            showCancelButton: true,
            confirmButtonText: 'Submit',
          })
    
          if (isConfirmed) {
            await this.submitToNewLevel('assigned date', record, inspectionDate)
          }
        }
      }
    },
    {
      text: 'Approve',
      icon: 'check',
      roles: [['field_officer', 'inspector', 'senior_officer']],
      test: r => {
        if (['pending', 'processing', 'document requested'].includes(r.application_decision) && r.reviewer_id == $app.current_user.id) {
          return true
        }

        return false
      },
      fn: async record => {
        // Certificate of Sanitation expiry, defaulting to one year from today
        const { isConfirmed, value: licenseExpiryDate } = await Swal.fire({
          icon: 'success',
          title: 'Confirm Approval',
          html: `
            <p>
              Are you sure you want to approve this application for
              <strong>${fullName(record.user, 'initial')}</strong>?
            </p>
            Please enter the expiry date for the Certificate of Sanitation being issued with this approval.

            <div>
              <input type="date" id="license-expiry-date" class="swal2-input"
                min="${moment().add(1, 'day').format('YYYY-MM-DD')}"
                value="${moment().add(1, 'year').format('YYYY-MM-DD')}">
            </div>
          `,
          confirmButtonText: 'Approve',
          showCancelButton: true,
          preConfirm: () => {
            const date = document.getElementById('license-expiry-date').value

            if (!date || !moment(date).isAfter(moment(), 'day')) {
              Swal.showValidationMessage('Please select an expiry date after today')
            }

            return date
          },
        })

        if (isConfirmed) {
          await this.submitToNewLevel('approved', record, null, licenseExpiryDate)
        }
      },
    },
    {
      text: 'Deny',
      icon: 'ban',
      roles: [['field_officer', 'inspector', 'senior_officer']],
      test: r => {
        if (['pending', 'processing', 'document requested'].includes(r.application_decision) && r.reviewer_id == $app.current_user.id) {
          return true
        }

        return false
      },
      fn: record =>
        Swal.fire({
          icon: 'error',
          title: 'Confirm Denial',
          text: 'Are you sure you want to deny this application?',
          confirmButtonText: 'Deny',
          showCancelButton: true,
        }).then(async result => {
          if (result.isConfirmed) {
            await this.submitToNewLevel('denied', record, null)
          }
        }),
    },
  ]

  submitToNewLevel = async (value, record, inspectionDate = null, licenseExpiryDate = null) => {
    this.setState({ loading: true })
    const { resource, form_key } = this
    const { axios } = $app

    try {
      await axios.put(resource + '/update_application', {
        [form_key]: {
          form_num: record.form_num,
          application_decision: value,
          inspection_date: inspectionDate,
          license_expiry_date: licenseExpiryDate,
        },
      })

      toastr.success('Success', 'The application was successfully updated')
    } catch (error) {
      console.error(error)
      toastr.error('Error', error.response?.data?.error || 'Something went wrong with trying to update this application')
    } finally {
      this.setState({ loading: false })
    }
  }

  columns = props => [
    {
      name: 'Vendor Type',
      selector: row => row.vendor_type ? row.vendor_type.capitalize() : 'N/A',
      sortable: true,
      searchable: r => r.vendor_type,
    },
    {
      name: 'Inspection Date',
      selector: row => row.inspection_date ? moment(row.inspection_date).format('MMMM Do YYYY') : 'N/A',
      sortable: true,
      searchable: r => r.inspection_date,
    },
    {
      name: 'Officer Assigned',
      width: '200px',
      selector: row => row.reviewer ? `
        ${row.reviewer.first_name[0].toUpperCase() + row.reviewer.first_name.substring(1)} ${row.reviewer.last_name[0].toUpperCase() + row.reviewer.last_name.substring(1)}
      ` : 'N/A',
      sortable: true,
      // searchable: r => r.reviewer,
    },
  ]

  validate = async form => {
    // const update = {}

    // Validation: Ensure that at least one option is checked for the vendor type checklist
    if (form.vendor_type.trim() === '') {
      return 'No application type was selected'
    }

    // return update
  }

  foremost = null

  fields = form => [
    ...BUSINESS_FIELDS(form),

    {
      name: 'inspection_date',
      type: 'date',
      showYearDropdown: true,
      hide: true,
      view: {
        label: 'Inspection Date',
        value: v => (v ? moment(v).format('MMMM Do YYYY, h:mm a') : 'N/A')
      },
    },

    "::Vendor Information",
    {
        name: "address",
        label: "Home Address",
        hint: "eg. Centerville, Collins Avenue, #5"
    },
    {
        name: "organization_name",
        label: "Name of Organization",
        hint: 'Leave blank if not applicable',
        required: false
    },
    {
        name: "phone_contact",
        label: "Phone Contact #",
        type: "phone",
        required: false
    },
    // {
    //     name: "email",
    //     type: "email"
    // },
    {
        name: "vendor_type",
        label: "Type of Food Vendor",
        type: "checklist",
        single: true,
        options: [
            { label: "School Lunch Vendor", value: "school lunch vendor" },
            { label: "Mobile Vendor", value: "mobile vendor" },
            { label: "Hot Dog Vendor", value: "hot dog vendor" },
            { label: "Pre-Packaged Vendor", value: "pre packaged vendor" },
            { label: "Seafood Vendor", value: "seafood vendor" },
            { label: "Fruit & Vegetable Vendor", value: "fruit & vegetable vendor" },
            { label: "Social Services Vendor", value: "social services vendor" },
            { label: "Catering Vendor", value: "catering vendor" },
            { label: "Temporary/Cook-Out Vendor", value: "temporary/cook-out vendor" },
        ],
        // multi: true
    },
    {
      name: 'date_of_event',
      type: 'date',
      showYearDropdown: true,
      hide: !['catering vendor', 'temporary/cook-out vendor'].includes(form.vendor_type),
      view: {
        label: 'Date of Event',
        value: v => (v ? moment(v).format('MMMM Do YYYY, h:mm a') : 'N/A')
      },
    },
    {
      heading: `
          <h5>Required Documents</h5>
          <span style='font-size: 0.95rem;'>Documents must be up to date and valid at the time of application.</span>
      `
    },
    {
      name: "moe_approval_upload",
      label: "Ministry of Education Approval",
      type: "file:all",
      key: "image.1",
      hide: !['school lunch vendor', 'social services vendor'].includes(form.vendor_type)
    },
    // {
    //     name: "mow_permit_upload",
    //     label: "Ministry of Works Permit",
    //     type: "file:all",
    //     key: "image.1"
    // },
    {
      name: "property_authorization_upload",
      label:'Property Authorization Letter',
      type: "file:all",
      key: "image.2",
      hide: ['school lunch vendor', 'social services vendor'].includes(form.vendor_type),
      hint: `Accepts: .pdf, .jpg, .jpeg, .png </br></br>
          Approval letter from property owner, whether from Ministry of Works for public property or from private landowner for private property
      `
    },
    {
      name: "health_cert_upload",
      label: "Food Handler's Health Certificate",
      type: "file:all",
      key: "image.3"
    },
    {
      name: "water_and_sewage_upload",
      label: "Water and Sewage Corporation Form Approval",
      type: "file:all",
      key: "image.4"
    },
    {
      name: "garbage_collection_contract_upload",
      label: "Contract for Collection of Garbage",
      type: "file:all",
      key: "image.5",
      hide: ['temporary/cook-out vendor', 'hot dog vendor'].includes(form.vendor_type),
      hint: `Accepts: .pdf, .jpg, .jpeg, .png </br></br>
          Contract for collection of garbage from a licensed waste management company
      `
    },
  ]

  render = () => <Wizard {...SERVICE_PROPS(this)} />
}
